import request from "../../utils/request";
import { Result } from "../../models/general";

export type AttendanceCorrectionRequest = {
  id: string;
  requestId: number;
  userId: string;
  date: string;
  type: string;
  requestedCheckIn?: string | null;
  requestedCheckOut?: string | null;
  requestedBreakIn?: string | null;
  requestedBreakOut?: string | null;
  currentCheckIn?: string | null;
  currentCheckOut?: string | null;
  currentBreakIn?: string | null;
  currentBreakOut?: string | null;
  reason: string;
  status: "pending" | "approved" | "rejected" | string;
  submittedDate: string;
  approvedDate?: string | null;
  rejectedDate?: string | null;
  approver?: string | null;
  rejectionReason?: string | null;
  attachments?: string[];
  comments?: { author: string; text: string; date: string }[];
  workflow?: { stage: string; status: string; date?: string | null; actor: string }[];
  /** CO-814 — approved without a human decision (HR's approval bypass). Status stays "approved". */
  autoApproved?: boolean;
  autoApprovalReason?: "ApprovalBypass" | "WorkflowAutoApproval" | "PolicyNoApprovalRequired" | null;
  /** CO-814 — who decided (null while pending and when auto-approved). Prefer over `approver`. */
  decidedByName?: string | null;
  /** CO-814 — who a pending request waits on; only on the requester's own list (My). */
  pendingWith?: "Manager" | "Hr" | "Chief" | "Unroutable" | null;
};

export type AttendanceCorrectionRequestCreateInput = {
  date: string;
  type: string;
  requestedCheckIn?: string;
  requestedCheckOut?: string;
  requestedBreakIn?: string;
  requestedBreakOut?: string;
  reason: string;
  userId?: string;
};

export async function getMyCorrectionRequests(userId?: string) {
  const path = userId
    ? `AttendanceCorrectionRequests/My/${encodeURIComponent(userId)}`
    : `AttendanceCorrectionRequests/My`;
  const response = await request.get<Result<AttendanceCorrectionRequest[]>>(path);
  return response.data;
}

export async function getAssignedCorrectionRequests(userId?: string) {
  const path = userId
    ? `AttendanceCorrectionRequests/Assigned/${encodeURIComponent(userId)}`
    : `AttendanceCorrectionRequests/Assigned`;
  const response = await request.get<Result<AttendanceCorrectionRequest[]>>(path);
  return response.data;
}

export async function createCorrectionRequest(input: AttendanceCorrectionRequestCreateInput) {
  const response = await request.post<Result<AttendanceCorrectionRequest>>(
    `AttendanceCorrectionRequests/Create`,
    input
  );
  return response.data;
}

export async function decideCorrectionRequest(input: { requestId: number; isApproved: boolean; comment?: string }) {
  const response = await request.post<Result<boolean>>(`AttendanceCorrectionRequests/Decision`, {
    requestId: input.requestId,
    isApproved: input.isApproved,
    comment: input.comment,
  });
  return response.data;
}
